import script from "./BreadcrumbList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BreadcrumbList.vue?vue&type=script&lang=ts&setup=true"

import "./BreadcrumbList.vue?vue&type=style&index=0&id=258ad3ef&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258ad3ef"]])

export default __exports__